import React from "react";
import { Asterisk } from "lucide-react";
import { cn } from "@/lib/utils";

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormField({ label, required = false, error, children, className }: FormFieldProps) {
  return (
    <div className={cn("flex flex-col gap-[8px]", className)}>
      <div className="flex items-center gap-[5px] min-w-0">
        <label className="font-bold text-off-black text-base truncate">{label}</label>
        {required && <Asterisk className="w-[8px] h-[8px] text-off-red flex-shrink-0" />}
      </div>
      {children}
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  );
}
